import { Component, inject, OnInit } from '@angular/core';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import {
  CategoryItem,
  CategorySelectorComponent,
} from '../../../custom-input/category-selector/category-selector.component';
import { ActivityFormService } from 'src/app/trip-calculator/services/activity-form.service';
import { ActivityType } from 'src/app/trip-calculator/models/activity';


@Component({
  selector: 'app-select-activity-type',
  imports: [TranslocoPipe, CategorySelectorComponent],
  templateUrl: './select-activity-type.component.html',
})
export class SelectActivityTypeComponent implements OnInit {
  activityFormService = inject(ActivityFormService);
  translocoService = inject(TranslocoService);
  typeList: CategoryItem[] = [];

  ngOnInit() {
    this.initializeTypeList();
  }

  initializeTypeList() {
    this.typeList = [];
    for (const type of Object.values(ActivityType)) {
      if (
        type === ActivityType.CustomFactor &&
        !this.activityFormService.hasCustomFactor
      ) {
        continue;
      }

      this.typeList.push({
        value: type,
        label: this.translocoService.translate('categoryType.' + type),
      });
    }
  }

  get type() {
    const type = this.activityFormService.activityForm.get('type')?.value;
    return type ? type : '';
  }

  set type(value) {
    this.activityFormService.activityForm.get('type')?.setValue(value);
  }
}
